import styled from "styled-components";

export const PageContent = styled.div`
  width: 100%;
`

export const MainContainer = styled.div`
  .infos {
    margin-bottom: 28px;

    .titleContainer {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
    }

    h3 {
      color: #353535;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 1.5rem;
      line-height: 29px;
      margin: 0;
    }
  }

  .button {
    width: 134px;
    height: 40px;
    background: #89BD23;
    color: #FFF;
    padding-left: 44px;
  }

  .spacer {
    height: 96px;
  }

  @media screen and (max-width: 600px){

    .toolbar {
      input.toolbarInput {
        width: 75vw;
      }
    }

    button {
      width: auto;
    }

    .infos{
      margin-bottom: 20px;
      h3{
        font-size: 17px;
      }
    }

    .filterContainer {
      left: 32vw;
    }

    th:first-of-type {
      padding: 6px 0 !important;
    }

  }
`
